var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9128 13.6572C13.4367 13.8318 14.003 13.5487 14.1777 13.0247C14.3523 12.5008 14.0692 11.9345 13.5452 11.7598L12.9128 13.6572ZM10.4165 11.771H9.4165C9.4165 12.2014 9.69193 12.5836 10.1003 12.7197L10.4165 11.771ZM11.4165 7.85089C11.4165 7.2986 10.9688 6.85089 10.4165 6.85089C9.86422 6.85089 9.4165 7.2986 9.4165 7.85089H11.4165ZM13.5452 11.7598L10.7327 10.8223L10.1003 12.7197L12.9128 13.6572L13.5452 11.7598ZM11.4165 11.771V7.85089H9.4165V11.771H11.4165ZM16.9165 10.8335C16.9165 14.4233 14.0064 17.3335 10.4165 17.3335V19.3335C15.1109 19.3335 18.9165 15.5279 18.9165 10.8335H16.9165ZM10.4165 17.3335C6.82665 17.3335 3.9165 14.4233 3.9165 10.8335H1.9165C1.9165 15.5279 5.72208 19.3335 10.4165 19.3335V17.3335ZM3.9165 10.8335C3.9165 7.24364 6.82665 4.3335 10.4165 4.3335V2.3335C5.72208 2.3335 1.9165 6.13908 1.9165 10.8335H3.9165ZM10.4165 4.3335C14.0064 4.3335 16.9165 7.24364 16.9165 10.8335H18.9165C18.9165 6.13908 15.1109 2.3335 10.4165 2.3335V4.3335Z",
    fill: "#FFB000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.e6aa4ca238fac75bee46ad7f6a6bf08f.svg";
export { ForwardRef as ReactComponent };